import { UpdateWorkspaceRequest } from 'trace-backend-sdk';
import { identify, makeRequest, Service } from '../../../utils/http';

type Data = UpdateWorkspaceRequest;

export async function updateWorkspaceApi(data: Data) {
  return makeRequest(Service.updateWorkspace(data, await identify()));
}
